import { createRepository } from '@/shared/repositories/Repository'
import { GET_SERVERS_URL } from '@/shared/api'
import type { ServerListResponse } from '../model/types'

const serverRepository = createRepository({
  basePath: GET_SERVERS_URL,
  useAuth: true // Изменяем на true - возможно сервер требует авторизации
})

export const getServers = async (): Promise<{ status: number; data: ServerListResponse }> => {
  // Получение списка серверов для покупки подписки
  
  const errors = {
    401: 'Необходима авторизация для получения списка серверов',
    403: 'Нет доступа к получению списка серверов',
    404: 'Эндпоинт серверов не найден',
    500: 'Ошибка сервера при загрузке списка серверов'
  }
  
  return serverRepository.get<ServerListResponse>('', undefined, errors)
}
